import script from "./PaymentHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./PaymentHistoryModal.vue?vue&type=style&index=0&id=16733ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16733ba0"]])

export default __exports__